/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DocumentShareFormFromJSON, DocumentShareFormToJSON } from './DocumentShareForm';
export function GetContactShareDocumentShareFormsResponseDataFromJSON(json) {
    return GetContactShareDocumentShareFormsResponseDataFromJSONTyped(json, false);
}
export function GetContactShareDocumentShareFormsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        shareForms: !exists(json, 'share_forms')
            ? undefined
            : json['share_forms'].map(DocumentShareFormFromJSON)
    };
}
export function GetContactShareDocumentShareFormsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        share_forms: value.shareForms === undefined ? undefined : value.shareForms.map(DocumentShareFormToJSON)
    };
}
